<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Исторические карты
    </h1>
    <!-- <CommonComplexFiltering
      class="mb-[20px]"
      :rubrics-list="documentRubrics?.data?.value"
      is-centuries-disabled
      :filters-active="filters"
    /> -->
    <div
      class="grid grid-cols-1 gap-[20px] md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6"
    >
      <MainPageCardsReworkedHistoricalMapsCard
        v-for="maps in historicalMaps?.data?.value"
        :key="maps.id"
        class="col-span-1 min-h-[401px]"
        :data="maps"
        :priority-image="maps.images?.[0]?.preview"
      />
    </div>
  </article>
</template>

<script setup>
const route = useRoute();

const filters = computed(() => {
  return {
    categories: route.query?.category,
  };
});

// const { documents: documentRubrics } = useDocuments();
const { historicalMaps } = useHistoricalMaps(filters);

useHead({
  title: 'Исторические карты | Читать на Федеральном портале Истории России',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
});
</script>
